<template>
    <b-modal
        :id="id"
        :title="title"
        no-close-on-esc
        no-close-on-backdrop
        centered
        @shown="onShown"
        @hidden="onHidden"
    >
        <slot />
        <b-alert show variant="warning" class="mt-3">
            <h6 class="font-weight-bold">Pernyataan</h6>
            <slot name="statement" />
            <b-form-checkbox v-model="isChecked">
                {{ checkboxText }}
            </b-form-checkbox>
        </b-alert>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" :disabled="isSubmitting" @click="cancel()">
                {{ cancelText }}
            </b-button>
            <b-button
                :variant="okVariant"
                :disabled="isSubmitting || !isChecked"
                @click="onSubmit"
            >
                <b-spinner v-if="isSubmitting" small class="mr-1" />
                {{ okText }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "statement-confirm-modal",
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        isSubmitting: {
            type: Boolean,
            default: false,
        },
        okVariant: {
            type: String,
            default: "pgiBtn",
        },
        okText: {
            type: String,
            default: "Ya",
        },
        cancelText: {
            type: String,
            default: "Batal",
        },
        checkboxText: {
            type: String,
            default: "Saya telah membaca dan menyetujui pernyataan di atas.",
        },
    },
    data() {
        return {
            isChecked: false,
            alertAudio: null,
        };
    },
    methods: {
        onShown() {
            this.isChecked = false;
            document.body.classList.add("statement-confirm-alert-blink");
            this.playAlertSound();
        },
        onHidden() {
            this.isChecked = false;
            this.stopAlertSound();
        },
        playAlertSound() {
            if (!this.alertAudio) {
                this.alertAudio = new Audio("/alert-sound.mp3");
                this.alertAudio.loop = true;
            }

            this.alertAudio.currentTime = 0;
            const playPromise = this.alertAudio.play();
            if (playPromise && playPromise.catch) {
                playPromise.catch(() => {});
            }
        },
        stopAlertSound() {
            document.body.classList.remove("statement-confirm-alert-blink");
            if (!this.alertAudio) return;
            this.alertAudio.pause();
            this.alertAudio.currentTime = 0;
        },
        onSubmit() {
            if (!this.isChecked) {
                this.$helper.toastErr(this, "Pernyataan wajib disetujui.");
                return;
            }

            this.$emit("submit");
        },
    },
    beforeDestroy() {
        this.stopAlertSound();
    },
};
</script>

<style>
body.statement-confirm-alert-blink::before {
    content: "";
    position: fixed;
    inset: 0;
    z-index: 1045;
    pointer-events: none;
    animation: statement-confirm-alert-blink 0.6s infinite;
}

@keyframes statement-confirm-alert-blink {
    0%, 100% {
        background: rgba(220, 53, 69, 0.16);
    }

    50% {
        background: rgba(255, 193, 7, 0.18);
    }
}
</style>
